import React from 'react';
import PropTypes from 'prop-types';
import { Popover, OverlayTrigger } from 'react-bootstrap';

// TODO: fix issue with eslint import resolver
import { useFlags, useLabels } from 'wsm-common-data'; // eslint-disable-line import/no-unresolved
import '../global-sass/main.scss';

export const QuickSpecsIDC = ({ quickSpecs, deviceType }) => {
	const flags = useFlags();
	const labels = useLabels();

	const popoverPlacement = deviceType === 'MOBILE' ? 'top' : 'right';
	const popoverHoverFocus = (
		<Popover id="quick-specs-popover">
			{labels.get('MPG_ESTIMATE_DISCLAIMER')}
		</Popover>
	);

	const renderSpec = item => {
		switch (item.name) {
			case 'fuelEconomy':
				return [
					<OverlayTrigger
						trigger={['hover', 'focus']}
						placement={popoverPlacement}
						overlay={popoverHoverFocus}
					>
						<span>
							{labels.get(item.label)}
							<i className="ddc-icon ddc-icon-info text-muted ddc-icon-size-small d-inline-block pl-1" />
						</span>
					</OverlayTrigger>,
					<span>
						{`${item.itemValue} ${labels.get(item.unitLabel)}`}
					</span>
				];
			case 'odometer':
				return [
					labels.get(item.label),
					<span>
						{`${item.itemValue} ${labels.get(item.unitLabel)}`}
					</span>
				];
			case 'interiorColor':
			case 'exteriorColor':
				return [
					labels.get(item.label),
					<div className="normalized-swatch-container exteriorColor">
						<span
							className={`normalized-swatch normalized-swatch-${item?.normalColor?.toLowerCase() ||
								''}`}
						/>
						<span>{item.itemValue}</span>
					</div>
				];
			default:
				return [labels.get(item.label), <span>{item.itemValue}</span>];
		}
	};

	const renderItems = items =>
		items.map(item => {
			const [dtVal, ddVal] = renderSpec(item);
			return [
				<dt className="text-muted col-xs-5">{dtVal}</dt>,
				<dd key={item.name} className="col-xs-7 p-0">
					{ddVal}
				</dd>
			];
		});

	const quickSpecsIDCFlag = flags['ws-quick-specs-enable-idc-service'];
	if (quickSpecsIDCFlag) {
		if (deviceType === 'MOBILE' || quickSpecs.length === 1) {
			return renderItems(quickSpecs);
		}
		const middleItemIndex = Math.floor(quickSpecs.length / 2);
		const firstColumn = quickSpecs.slice(0, middleItemIndex + 1);
		const secondColumn = quickSpecs.slice(middleItemIndex + 1);
		return (
			<div className="row">
				<div className="col-xs-6">
					<dl className="line-height-condensed dl-horizontal row list-spaced">
						{renderItems(firstColumn)}
					</dl>
				</div>
				<div className="col-xs-6">
					<dl className="line-height-condensed dl-horizontal row list-spaced">
						{renderItems(secondColumn)}
					</dl>
				</div>
			</div>
		);
	} else {
		return null;
	}
};

QuickSpecsIDC.propTypes = {
	quickSpecs: PropTypes.shape([]).isRequired
};
